// extracted by mini-css-extract-plugin
export var btn = "resourceListing-module--btn--f0ac7";
export var resourcesListingWrapper = "resourceListing-module--resourcesListingWrapper--80697";
export var showAllButtonMinus = "resourceListing-module--showAllButtonMinus--39789";
export var showAllButtonPlus = "resourceListing-module--showAllButtonPlus--2284b";
export var uiButton = "resourceListing-module--uiButton--aef83";